// Méta-données du cockpit « Performance commerciale ».
import { initials, avatarColor, fmtDate } from '../ops-team/opsMeta';
import { fmtXof } from '../recouvrement/recMeta';

export { initials, avatarColor, fmtDate, fmtXof };

export const fmtPct = (n) => `${Number(n ?? 0).toLocaleString('fr-FR', { maximumFractionDigits: 1 })} %`;

// Mois courant au format YYYY-MM
export const currentMonth = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};

// 12 derniers mois pour le sélecteur de période
export const lastMonths = (n = 12) => {
  const out = [];
  const d = new Date();
  for (let i = 0; i < n; i += 1) {
    const dt = new Date(d.getFullYear(), d.getMonth() - i, 1);
    const value = `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}`;
    const label = dt.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' });
    out.push({ value, label: label.charAt(0).toUpperCase() + label.slice(1) });
  }
  return out;
};

export const monthLabel = (period) => {
  if (!period) return '';
  const [y, m] = period.split('-');
  const dt = new Date(Number(y), Number(m) - 1, 1);
  const l = dt.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' });
  return l.charAt(0).toUpperCase() + l.slice(1);
};

export const ROLE_LABEL = { commercial: 'Commercial', lead_commercial: 'Lead Commercial' };

// Statut d'un commercial dérivé de ses KPIs
export const rowStatus = (r) => {
  const noActivity = (r.ca?.realised || 0) === 0 && (r.ops?.realised || 0) === 0 && (r.invoices?.realised || 0) === 0;
  if ((r.ca?.target || 0) === 0) return { key: 'no_target', label: 'Sans objectif', cls: 'bg-amber-50 text-amber-700 ring-amber-200' };
  if (noActivity) return { key: 'no_activity', label: 'Sans activité', cls: 'bg-gray-100 text-gray-500 ring-gray-200' };
  if ((r.ca?.pct || 0) < 50) return { key: 'watch', label: 'À suivre', cls: 'bg-orange-50 text-orange-700 ring-orange-200' };
  return { key: 'active', label: 'Actif', cls: 'bg-emerald-50 text-emerald-700 ring-emerald-200' };
};

export const MEDALS = { 1: '🥇', 2: '🥈', 3: '🥉' };

export const progressColor = (pct) => (pct >= 100 ? 'bg-emerald-500' : pct >= 50 ? 'bg-blue-500' : pct > 0 ? 'bg-orange-400' : 'bg-gray-300');
